/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from "classnames";
import { Link } from "react-router";
import utils from "@utils";
import { useDisputeContext } from "../../../../context/DisputeContext";
import TrashIcon from "../../../../../../../images/trash-icon.svg";
import TimeHoverTooltip from "../../TimeHoverTooltip";

const OfficerNonRKPayInvoiceItemForm = ({
	user,
	user: { TimeZoneId },
	item,
	nonRKPayInvoiceDetailHook,
	getDisputeReasonsByJobId
}) => {
	const { lang } = global;

	const {
		openDeleteJobConfirmation,
		isLineItemTimeCardEditable,
		onClickEditInvoiceLineItemTimeCard,
		handlePositionChange,
		handlePositionChangedOnBlur,
		loadingInvoiceTotals,
		handleShowDeleteChange,
		isAnyLineItemFinalizedForJobEvent,
	} = nonRKPayInvoiceDetailHook;

	const {
			registerCardRef,
			openDisputeReason,
		} = useDisputeContext()

	const disputeReasons = getDisputeReasonsByJobId(item.JobId);
	const disputeReason = disputeReasons?.find(({ Id }) => Id === openDisputeReason)
	const isDisputed = !!disputeReason;
	const buttonClass = classNames(
		"btn", {
		"btn-link": !isDisputed,
		"btn-link-danger": isDisputed,
	});
	const textClass = classNames({
		"text-danger": isDisputed,
	})
	const inputContainerClass = classNames("col-xs-6 col-md-1 form-group", {
		"invalid-field": isDisputed,
	});

	return (
		<div
			ref={(ref) => {
				if (ref && disputeReason) registerCardRef(disputeReason.Id, ref)
			}}
			className={classNames("col-sm-12 job-item", {
				"cursor-pointer": isDisputed
			})}
			key={`assignment_${item.JobAssignmentId}`}
			onMouseEnter={() =>
				handleShowDeleteChange(item.JobEventId)
			}
			onMouseLeave={() => handleShowDeleteChange("")}
		>
			<div className="row">
				<div className="col-xs-12 col-md-3 col-md-offset-3">
					<strong className="hidden-md hidden-lg">
						{lang.t("Job Name")}:{" "}
					</strong>
					<span className="hidden-md hidden-lg">
						<Link
							to={`/jobs/${item.JobEventId}`}
						>
							<span
								className={textClass}
							>
								{`${item.JobEventTitle} (${item.JobEventId})`}
							</span>
						</Link>
					</span>
					<strong className="hidden-xs hidden-sm">
						<Link
							to={`/jobs/${item.JobEventId}`}
						>
							<span
								className={textClass}
							>
								{`${item.JobEventTitle} (${item.JobEventId})`}
							</span>
						</Link>
					</strong>
					<em className="hidden-md hidden-lg padding-left-4">
						<small>{item.JobTitle}</small>
					</em>
					<br className="hidden-xs hidden-sm" />
					<em className="hidden-xs hidden-sm">
						{item.JobTitle}
					</em>
					{!isAnyLineItemFinalizedForJobEvent(item) && (
						<button
							type="button"
							className="btn btn-link text-center delete-job-dt"
							onClick={() =>
								openDeleteJobConfirmation(
									item.JobEventId,
								)
							}
						>
							<img
								className="trash-icon hidden-md hidden-lg"
								src={TrashIcon}
								width="15"
								height="15"
								alt="Remove Job"
								aria-label="Remove Job"
							/>
							<img
								className="trash-icon hidden-xs hidden-sm"
								src={TrashIcon}
								width="20"
								height="20"
								alt="Remove Job"
								aria-label="Remove Job"
							/>
						</button>
					)}
				</div>
				<div className="col-xs-12 col-md-3">
					<div className="card-only v-align">
						<strong>
							{lang.t("Date")} &amp; {lang.t("Time")}:{" "}
						</strong>
						<span className={classNames("padding-right-4 padding-left-4", textClass)}>
							{
								utils.splitDateTimeComponents(
									item.JobStartTime,
									TimeZoneId,
									user.UserPreferences ===
									"useMilitaryTime",
								).date
							}
						</span>
						<TimeHoverTooltip
							item={item}
							TimeZoneId={TimeZoneId}
							user={user}
							disputed={isDisputed}
						/>
					</div>
					<div className="hidden-xs hidden-sm">
						<p
							className={classNames("padding-right-4 padding-left-4", textClass)}
						>
							{
								utils.splitDateTimeComponents(
									item.JobStartTime,
									TimeZoneId,
									user.UserPreferences ===
									"useMilitaryTime",
								).date
							}
						</p>
						<TimeHoverTooltip
							item={item}
							TimeZoneId={TimeZoneId}
							user={user}
							disputed={isDisputed}
						/>
					</div>
					{isLineItemTimeCardEditable(item) && (
						<button
							type="button"
							className={buttonClass}
							onClick={onClickEditInvoiceLineItemTimeCard(
								item,
							)}
						>
							<i className="rkf rkf-Timecard" />
							<span className="margin-left-2">
								{lang.t("Timecard")}
							</span>
						</button>
					)}
				</div>
				<div className={`${inputContainerClass} div-rate-number-padding`}>
					<label
						className="card-only"
						htmlFor={`positionRate-${item.JobAssignmentId}`}
					>
						<strong>{`${lang.t("Rate")} ($)`}</strong>
					</label>
					<input
						type="number"
						id={`positionRate-${item.JobAssignmentId}`}
						name={`positionRate-${item.JobAssignmentId}`}
						className="form-control"
						value={item.Rate}
						onChange={handlePositionChange(
							item.JobAssignmentId,
							"Rate",
						)}
						disabled={loadingInvoiceTotals}
						onBlur={() =>
							handlePositionChangedOnBlur(
								item.JobAssignmentId,
							)
						}
					/>
					<div className="visible-print-block">
						{utils.currencyFormatter(item.Rate)}
					</div>
				</div>
				<div className={`${inputContainerClass} div-hours-number-padding`}>
					<label
						className="card-only"
						htmlFor={`positionHours-${item.JobAssignmentId}`}
					>
						<strong>{lang.t("Hours")}</strong>
					</label>
					<input
						type="number"
						id={`positionHours-${item.JobAssignmentId}`}
						name={`positionHours-${item.JobAssignmentId}`}
						className="form-control"
						value={item.Hours}
						onChange={handlePositionChange(
							item.JobAssignmentId,
							"Hours",
						)}
						disabled={loadingInvoiceTotals}
						onBlur={() =>
							handlePositionChangedOnBlur(
								item.JobAssignmentId,
							)
						}
					/>
					<div className="visible-print-block">
						{item.Hours}
					</div>
				</div>
				<div className="col-xs-12 col-md-1 text-right print-amount">
					<strong className="card-only">
						{lang.t("Total")}:&nbsp;
					</strong>
					<span
						className={textClass}
					>
						{utils.currencyFormatter(item.OfficerPayAmount)}
					</span>
				</div>
			</div>
		</div>
	)
}

OfficerNonRKPayInvoiceItemForm.propTypes = {
	user: PropTypes.object,
	item: PropTypes.object,
	nonRKPayInvoiceDetailHook: PropTypes.object.isRequired,
	getDisputeReasonsByJobId: PropTypes.func.isRequired,
};

OfficerNonRKPayInvoiceItemForm.defaultProps = {
	user: {},
	item: {},
};

export default OfficerNonRKPayInvoiceItemForm;
